export default "__VITE_PUBLIC_ASSET__a26c35e9__"